var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilters(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_16121",
    "data-name": "Group 16121",
    transform: "translate(-1536 -144)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3422",
    "data-name": "Rectangle 3422",
    width: 30,
    height: 30,
    transform: "translate(1536 144)",
    fill: "#fff",
    opacity: 0
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_16140",
    "data-name": "Group 16140",
    transform: "translate(1539.907 147.52)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16133",
    "data-name": "Group 16133",
    transform: "translate(0 3.11)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16122",
    "data-name": "Group 16122",
    transform: "translate(8.478)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16121-2",
    "data-name": "Group 16121"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11406",
    "data-name": "Path 11406",
    d: "M206.47,72.074H193.712a.622.622,0,0,1,0-1.244H206.47a.622.622,0,1,1,0,1.244Z",
    transform: "translate(-193.09 -70.83)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_16124",
    "data-name": "Group 16124",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16123",
    "data-name": "Group 16123",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11407",
    "data-name": "Path 11407",
    d: "M2.876,72.074H.622a.622.622,0,0,1,0-1.244H2.876a.622.622,0,0,1,0,1.244Z",
    transform: "translate(0 -70.83)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_16126",
    "data-name": "Group 16126",
    transform: "translate(18.139 7.508)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16125",
    "data-name": "Group 16125"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11408",
    "data-name": "Path 11408",
    d: "M416.849,243.074h-3.1a.622.622,0,0,1,0-1.244h3.1a.622.622,0,1,1,0,1.244Z",
    transform: "translate(-413.13 -241.83)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_16128",
    "data-name": "Group 16128",
    transform: "translate(0 7.508)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16127",
    "data-name": "Group 16127"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11409",
    "data-name": "Path 11409",
    d: "M12.538,243.074H.622a.622.622,0,1,1,0-1.244H12.538a.622.622,0,1,1,0,1.244Z",
    transform: "translate(0 -241.83)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_16130",
    "data-name": "Group 16130",
    transform: "translate(8.478 15.016)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16129",
    "data-name": "Group 16129",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11410",
    "data-name": "Path 11410",
    d: "M206.47,414.074H193.712a.622.622,0,0,1,0-1.244H206.47a.622.622,0,1,1,0,1.244Z",
    transform: "translate(-193.09 -412.83)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_16132",
    "data-name": "Group 16132",
    transform: "translate(0 15.016)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16131",
    "data-name": "Group 16131",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11411",
    "data-name": "Path 11411",
    d: "M2.876,414.074H.622a.622.622,0,0,1,0-1.244H2.876a.622.622,0,0,1,0,1.244Z",
    transform: "translate(0 -412.83)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_16135",
    "data-name": "Group 16135",
    transform: "translate(2.255 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16134",
    "data-name": "Group 16134"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11412",
    "data-name": "Path 11412",
    d: "M55.084,7.468a3.734,3.734,0,1,1,3.734-3.734A3.738,3.738,0,0,1,55.084,7.468Zm0-6.224a2.49,2.49,0,1,0,2.49,2.49,2.492,2.492,0,0,0-2.49-2.49Z",
    transform: "translate(-51.35 0)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_16137",
    "data-name": "Group 16137",
    transform: "translate(2.255 15.013)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16136",
    "data-name": "Group 16136"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11413",
    "data-name": "Path 11413",
    d: "M55.084,349.388a3.734,3.734,0,1,1,3.734-3.734A3.738,3.738,0,0,1,55.084,349.388Zm0-6.224a2.49,2.49,0,1,0,2.49,2.49A2.492,2.492,0,0,0,55.084,343.164Z",
    transform: "translate(-51.35 -341.92)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_16139",
    "data-name": "Group 16139",
    transform: "translate(11.916 7.506)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16138",
    "data-name": "Group 16138"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11414",
    "data-name": "Path 11414",
    d: "M275.124,178.428a3.734,3.734,0,1,1,3.734-3.734A3.738,3.738,0,0,1,275.124,178.428Zm0-6.223a2.49,2.49,0,1,0,2.49,2.489A2.492,2.492,0,0,0,275.124,172.2Z",
    transform: "translate(-271.39 -170.96)"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilters);
export default __webpack_public_path__ + "static/media/filters.a66f2bed800670eac2f96e84bbb09e3b.svg";
export { ForwardRef as ReactComponent };